/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactElement } from "react";
import Divider from "@mui/material/Divider";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CustomButton from "./Button";
import parse from "html-react-parser";

interface CustomConfirmProps {
  readonly title: string;
  readonly subTitle?: string;
  readonly message?: string;
  readonly width?: any;
  readonly isOpen: boolean;
  readonly handleSuccess: () => void;
  readonly handleClose: () => void;
  readonly actionBtnLabel: string;
  readonly hideSubmitBtn?: boolean;
  readonly disableSubmitBtn?: boolean;
  readonly additionalInfoSection?: ReactElement | null;
}
const CustomConfirm: React.FC<CustomConfirmProps> = ({
  title,
  subTitle,
  message,
  width,
  isOpen,
  handleSuccess,
  handleClose,
  actionBtnLabel,
  hideSubmitBtn,
  disableSubmitBtn,
  additionalInfoSection,
}) => {
  return (
    <Dialog
      fullWidth
      maxWidth={width}
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{fontFamily:'var(--font-family)'}}
    >
      <DialogTitle sx={{fontFamily:'var(--font-family)'}} id="custom-dialog-title">{title}</DialogTitle>
      <Divider />
      {message ? (
        <DialogContent>
          <DialogContentText sx={{fontFamily:'var(--font-family)'}} id="alert-dialog-description">
            {subTitle}
          </DialogContentText>
          {parse(message)}
        </DialogContent>
      ) : null}
      {additionalInfoSection ? (
        <DialogContent>
          <>{additionalInfoSection}</>
        </DialogContent>
      ) : null}
      <DialogActions sx={{ justifyContent: "flex-start" }}>
        {!hideSubmitBtn && (
          <CustomButton
            type="SmallBlueFixed"
            clickHandler={handleSuccess}
            disabled={disableSubmitBtn}
            label={actionBtnLabel}
          />
        )}
        <CustomButton
          type="SmallOutlined"
          clickHandler={handleClose}
          label="Cancel"
        />
      </DialogActions>
    </Dialog>
  );
};

CustomConfirm.defaultProps = {
  subTitle: "",
  message: "",
  width: "sm",
  actionBtnLabel: "Confirm",
  hideSubmitBtn: false,
  disableSubmitBtn: false,
  additionalInfoSection: null,
};

export default CustomConfirm;
